import { Area } from "recharts";
import type { ActiveDotType } from "recharts/types/util/types";

export const ChartArea: React.FC<{
    activeDot?: ActiveDotType;
    dataKey: string;
    dot?: boolean;
    fillColor: string;
    fillOpacity?: number;
    isAnimationActive?: boolean;
    name: string;
    onMouseEnter?: () => void; // CurveMouseEventHandler
    onMouseLeave?: () => void;
    strokeColor?: string;
    zIndex?: number;
}> = ({
    activeDot,
    dataKey,
    dot,
    fillColor,
    fillOpacity,
    isAnimationActive,
    name,
    onMouseEnter,
    onMouseLeave,
    strokeColor,
    zIndex,
}) => {
    const eventProps = {
        ...(onMouseEnter ? { onMouseEnter } : {}),
        ...(onMouseLeave ? { onMouseLeave } : {}),
    };

    return (
        <Area
            type="linear"
            dataKey={dataKey}
            dot={dot}
            fill={fillColor}
            fillOpacity={fillOpacity}
            isAnimationActive={isAnimationActive}
            name={name}
            stackId="1"
            stroke={strokeColor}
            zIndex={zIndex}
            activeDot={activeDot}
            {...eventProps}
        />
    );
};
